// removed by extract-text-webpack-plugin
module.exports = {"info":"ImageInfo__info___J2GqF","-clickable":"ImageInfo__-clickable___3oCov","badge":"ImageInfo__badge___1483R"};


//////////////////
// WEBPACK FOOTER
// ./application/js/components/ImageInfo.css
// module id = 520
// module chunks = 0